module.exports = __webpack_public_path__ + "static/salesberry-a6bb84b84814548b5ddfcb0f01813564.jpg";